import { AbilityBuilder, PureAbility } from "@casl/ability";

/** @type {any} */
const { can, cannot, build, rules } = new AbilityBuilder(PureAbility);

export { can, cannot, rules, build };

export default build();
